import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";

export interface AdminInvoice {
  id: string;
  amount: number;
  customer?: string;
  status?: "draft" | "open" | "paid" | "uncollectible" | "void";
  // invoiceLink?: string;
  dateSentTimestamp?: number;
}

export const useAdminInvoicesQuery = () => {
  const { getAccessTokenSilently } = useAuth0();
  const {
    data: adminInvoices,
    error: adminInvoicesError,
    isLoading: adminInvoicesLoading,
  } = useQuery({
    queryKey: QueryKeys.adminInvoices,
    enabled: true,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return await request<AdminInvoice[]>({
        method: "GET",
        path: "/api/admin/invoice",
        token,
      });
    },
  });

  return {
    adminInvoices,
    adminInvoicesError,
    adminInvoicesLoading,
  };
};
